// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__dK9D-","inner":"Footer_inner__2fbTj"};